(() => {
  'use strict';

  const CUSTOM_HANDLES = [
    'daily-nuuds-kadin-i̇c-camasiri-3-lu-kutu',
    'daily-nuuds-kadin-i̇c-camasiri-5-li-set'
  ];

  const decoded = (value) => {
    try { return decodeURIComponent(String(value || '')); } catch (_) { return String(value || ''); }
  };

  const normalizedText = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');

  const isCustomBuilderHref = (href) => {
    const value = decoded(href).toLocaleLowerCase('tr-TR');
    return CUSTOM_HANDLES.some((handle) => value.includes(handle.toLocaleLowerCase('tr-TR')));
  };

  const setStoredSource = (source) => {
    if (!source) return;
    window.__serranoBuilderSource = source;
    try { sessionStorage.setItem('serrano_builder_source', source); } catch (_) {}
  };

  const storedSource = () => {
    if (window.__serranoBuilderSource) return window.__serranoBuilderSource;
    try { return sessionStorage.getItem('serrano_builder_source') || ''; } catch (_) { return ''; }
  };

  const sourceFromPage = () => {
    const path = location.pathname;
    const params = new URLSearchParams(location.search);
    if (path.startsWith('/products/')) return 'PDP Builder';
    if (params.get('view') === 'kutunu-olustur' || path === '/pages/kutunu-olustur') return 'Builder Sayfası';
    if (path === '/' || path === '') return 'Ana Sayfa Builder';
    return 'Site İçi Builder';
  };

  const resolveSource = () => storedSource() || sourceFromPage();

  window.SerranoBuilderSource = {
    set: setStoredSource,
    resolve: resolveSource
  };

  const smoothScrollToBuilder = () => {
    const anchor = document.getElementById('serrano-home-builder');
    if (!anchor) return false;
    const scrollMargin = Number.parseFloat(getComputedStyle(anchor).scrollMarginTop) || 0;
    const top = Math.max(window.scrollY + anchor.getBoundingClientRect().top - scrollMargin, 0);
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    try {
      window.scrollTo({ top, behavior });
    } catch (_) {
      anchor.scrollIntoView({ behavior, block: 'start' });
    }
    return true;
  };

  const activateBuilder = (pack, cut, source) => {
    setStoredSource(source);
    const anchor = document.getElementById('serrano-home-builder');
    if (!anchor) return;
    let attempts = 0;
    const choose = () => {
      const builder = document.querySelector('dn-home-box-builder');
      const packButton = builder?.querySelector(`[data-pack="${pack}"]`);
      const cutButton = cut ? builder?.querySelector(`[data-cut="${cut}"]`) : null;
      if (builder?.dataset.ready === 'true' && packButton && (!cut || cutButton)) {
        packButton.click();
        cutButton?.click();
        requestAnimationFrame(() => smoothScrollToBuilder());
        setTimeout(() => smoothScrollToBuilder(), 180);
        return;
      }
      attempts += 1;
      if (attempts < 12) setTimeout(choose, 80);
    };
    choose();
  };

  const activatePack = (pack, source) => activateBuilder(pack, '', source);

  const makeClickable = (node, href, source = '') => {
    if (!node || !href || node.dataset.serranoClickable === 'true') return;
    node.dataset.serranoClickable = 'true';
    node.style.cursor = 'pointer';
    node.setAttribute('role', 'link');
    if (!node.hasAttribute('tabindex')) node.tabIndex = 0;

    const go = (event) => {
      if (event?.defaultPrevented) return;
      if (event?.target?.closest?.('a,button,input,select,textarea,[role="button"]')) return;
      if (source) setStoredSource(source);
      if (href.startsWith('#')) {
        event?.preventDefault?.();
        smoothScrollToBuilder();
      } else {
        window.location.assign(href);
      }
    };

    node.addEventListener('click', go);
    node.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (source) setStoredSource(source);
      if (href.startsWith('#')) smoothScrollToBuilder();
      else window.location.assign(href);
    });
  };

  const fixHero = (root = document) => {
    root.querySelectorAll?.('[id^="SerranoHero-"]').forEach((hero) => {
      hero.querySelectorAll('[data-slide]').forEach((slide) => {
        const href = slide.dataset.imageLink;
        const media = slide.querySelector('.sr-hero__media');
        if (!media || !href) return;
        const source = slide.dataset.blockId === 'hero_bundle' ? 'Ana Sayfa Hero' : '';
        makeClickable(media, href, source);
      });

      hero.querySelectorAll('[data-panel]').forEach((panel) => {
        const button = panel.querySelector('.sr-button');
        if (!button) return;

        if (panel.dataset.blockId === 'hero_thong') {
          button.dataset.serranoBuilderSource = 'Ana Sayfa The Thong Hero';
          if (button.dataset.serranoThongBuilder !== 'true') {
            button.dataset.serranoThongBuilder = 'true';
            button.addEventListener('click', (event) => {
              event.preventDefault();
              activateBuilder(3, 'Thong', 'Ana Sayfa The Thong Hero');
            });
          }
        }

        if (panel.dataset.blockId === 'hero_bundle') {
          button.dataset.serranoBuilderSource = 'Ana Sayfa Hero';
        }
      });
    });
  };

  const fixEditorial = (root = document) => {
    root.querySelectorAll?.('.se-benefit').forEach((card) => makeClickable(card, '/collections/daily-nuuds-tum'));

    root.querySelectorAll?.('.se-collection-card').forEach((card) => {
      const link = card.querySelector('.se-text-link[href]');
      if (link) makeClickable(card, link.getAttribute('href'));
    });

    root.querySelectorAll?.('.se-split--builder').forEach((split) => {
      const link = split.querySelector('.se-copy a[href]');
      const media = split.querySelector('.se-media');
      if (link && media) makeClickable(media, link.getAttribute('href'), 'Ana Sayfa Kutunu Oluştur');
    });

    root.querySelectorAll?.('.se-split--serrano').forEach((split) => {
      const link = split.querySelector('.se-copy a[href]');
      const media = split.querySelector('.se-media');
      if (link && media) makeClickable(media, link.getAttribute('href'));
    });
  };

  const fixBrands = (root = document) => {
    root.querySelectorAll?.('.ss-brand-card').forEach((card, index) => {
      const heading = card.querySelector('h3')?.textContent || '';
      if (index === 0 || heading.toLocaleLowerCase('tr-TR').includes('nuuds')) {
        makeClickable(card, '/collections/daily-nuuds-tum');
      }
    });
  };

  const fixHeader = (root = document) => {
    root.querySelectorAll?.('[data-serrano-header-shop-now] a, .site-header a.push-btn').forEach((link) => {
      if (normalizedText(link.textContent).includes('shop now')) link.setAttribute('href', '/collections/shop-all');
    });

    const routes = {
      'shop': '/collections/shop-all',
      'daily nuuds': '/collections/daily-nuuds-tum',
      '3’lü kutular': '/collections/3-lu-kutular',
      "3'lü kutular": '/collections/3-lu-kutular',
      '5’li kutular': '/collections/5-li-kutular',
      "5'li kutular": '/collections/5-li-kutular',
      'tekli zarflar': '/collections/tekli-zarflar',
      'classic kesim': '/collections/daily-nuuds-classic-bikini',
      'thong kesim': '/collections/daily-nuuds-thong',
      'tüm ürünleri gör': '/collections/shop-all'
    };

    root.querySelectorAll?.('.site-header a, [data-serrano-mega-nav] a').forEach((link) => {
      const key = normalizedText((link.textContent || '').replace(/→/g, ''));
      if (routes[key]) link.setAttribute('href', routes[key]);
    });

    // Shop dropdown's right campaign visual always leads to homepage builder.
    root.querySelectorAll?.('[data-serrano-mega-nav] .smn__panel--shop .smn__feature--orange').forEach((link) => {
      link.setAttribute('href', '/#serrano-home-builder');
      link.dataset.serranoBuilderSource = 'Header Kampanya Kartı';
    });
  };

  const fixBestSellerCta = (root = document) => {
    root.querySelectorAll?.('.sm-best-sellers .sms-view-all a, .sms .sms-view-all a').forEach((link) => {
      link.textContent = 'TÜM ÜRÜNLERİ GÖR';
      link.setAttribute('href', '/collections/shop-all');
      link.style.background = '#ff4712';
      link.style.borderColor = '#ff4712';
      link.style.color = '#25231f';
      link.style.fontWeight = '900';
      link.style.letterSpacing = '.08em';
      link.style.textTransform = 'uppercase';
      link.style.minHeight = '48px';
      link.style.padding = '13px 28px';
    });
  };

  const disableJournalMega = () => {
    const nav = document.querySelector('.site-header nav');
    if (!nav) return;
    nav.querySelectorAll(':scope > ul > li').forEach((item) => {
      const trigger = item.querySelector(':scope > a, :scope > button');
      if (!trigger || normalizedText(trigger.textContent) !== 'journal') return;
      if (item.dataset.serranoJournalPlain === 'true') return;

      const clone = item.cloneNode(true);
      const clonedTrigger = clone.querySelector(':scope > a, :scope > button');
      clone.dataset.serranoJournalPlain = 'true';
      if (clonedTrigger) {
        if (clonedTrigger.tagName === 'A') clonedTrigger.setAttribute('href', '/blogs/journal');
        clonedTrigger.removeAttribute('data-smn-trigger');
        clonedTrigger.removeAttribute('data-smn-active');
        clonedTrigger.removeAttribute('aria-haspopup');
        clonedTrigger.removeAttribute('aria-expanded');
        clonedTrigger.removeAttribute('aria-controls');
      }
      item.replaceWith(clone);
    });

    document.querySelectorAll('[data-smn-panel="journal"]').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.display = 'none';
    });
  };

  const fixBuilderTitleBar = (root = document) => {
    const params = new URLSearchParams(location.search);
    const isBuilderPage = params.get('view') === 'kutunu-olustur' || location.pathname === '/pages/kutunu-olustur';
    if (!isBuilderPage) return;
    root.querySelectorAll?.('.dnhb__eyebrow').forEach((node) => node.remove());
    root.querySelectorAll?.('.dnhb__band-inner').forEach((node) => {
      node.style.justifyContent = 'center';
      node.style.textAlign = 'center';
    });
  };

  const hideCustomListings = (root = document) => {
    root.querySelectorAll?.('a[href*="/products/"]').forEach((link) => {
      if (!isCustomBuilderHref(link.getAttribute('href') || link.href)) return;
      const item = link.closest('.se-ugc-product-item, .serrano-pdp-ready-products__item, .sms-grid > li, .serrano-shop-all-grid > li, [data-product-card], .product-tile');
      if (item) item.remove();
    });
  };

  document.addEventListener('click', (event) => {
    const savings = event.target.closest?.('.serrano-pack-savings__card');
    if (savings) {
      const pack = savings.matches('.serrano-pack-savings__upgrade')
        ? Number(savings.dataset.pack || 5)
        : (() => {
            const title = savings.querySelector('.serrano-pack-savings__title')?.textContent || '';
            return title.includes('3') ? 3 : title.includes('5') ? 5 : 0;
          })();
      if (pack) {
        const nativeBuilderAnchor = savings.matches('.serrano-pack-savings__upgrade')
          && String(savings.getAttribute('href') || '').startsWith('#');
        if (!nativeBuilderAnchor) event.preventDefault();
        event.stopImmediatePropagation();
        activatePack(pack, 'PDP Paket Avantajı');
        return;
      }
    }

    const directSource = event.target.closest?.('[data-serrano-builder-source]')?.dataset.serranoBuilderSource;
    if (directSource) setStoredSource(directSource);

    const builderLink = event.target.closest?.('a[href*="kutunu-olustur"], a[href="#serrano-home-builder"], a[href="/#serrano-home-builder"]');
    if (builderLink) {
      const source = builderLink.dataset.serranoBuilderSource || (builderLink.closest('.site-header,[data-serrano-mega-nav]')
        ? 'Header Builder'
        : builderLink.closest('[id^="SerranoHero-"]')
          ? 'Ana Sayfa Hero'
          : builderLink.closest('.se-band--builder')
            ? 'Ana Sayfa Kutunu Oluştur'
            : sourceFromPage());
      setStoredSource(source);
    }
  }, true);


  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && String(init.method || 'GET').toUpperCase() === 'POST' && typeof init.body === 'string') {
      try {
        const payload = JSON.parse(init.body);
        if (Array.isArray(payload?.items)) {
          let changed = false;
          payload.items.forEach((item) => {
            if (item?.properties && Object.prototype.hasOwnProperty.call(item.properties, '_Kaynak')) {
              item.properties._Kaynak = resolveSource();
              changed = true;
            }
          });
          if (changed) init = { ...init, body: JSON.stringify(payload) };
        }
      } catch (_) {}
    }
    return originalFetch(input, init);
  };

  const apply = (root = document) => {
    fixHeader(root);
    disableJournalMega();
    fixHero(root);
    fixEditorial(root);
    fixBrands(root);
    fixBestSellerCta(root);
    fixBuilderTitleBar(root);
    hideCustomListings(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  else apply(document);

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
